import React from 'react';
import { InputNumber } from '@components/framework/input/InputNumber';
import InputUnitPlain from '../InputUnitPlain/InputUnitPlain';

interface ComponentProps {
  quantity: number;
  quantityUnitCode: string;
  onChangeQuantity: (value: number) => void;
  onChangeQuantityUnitCode: (value: string) => void;
  disabled?: boolean;
  dataTestId?: string;
}

const InputQuantity: React.FC<ComponentProps> = ({ quantity, quantityUnitCode, onChangeQuantity, onChangeQuantityUnitCode, disabled = false, dataTestId }) => {
  return (
    <div data-testid={dataTestId}>
      <InputNumber
        minFractionDigits={0}
        maxFractionDigits={2}
        locale={'cs'}
        value={quantity}
        disabled={disabled}
        onChange={v => onChangeQuantity(v.value)}
        inputStyle={{ width: '100px' }}
      />
      <InputUnitPlain code={quantityUnitCode} onChange={v => onChangeQuantityUnitCode(v)} disabled={disabled} />
    </div>
  );
};

export default InputQuantity;
